/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABCklEQVR4nN2US04DMQyGu+IKvLriHPQCTO3fgxTZpffonAAxXId2V6nlMDz2wKarQaYPoULKKJ2RKiL9m9jx5ziOO51DWCQKhj6y6IeLxObAgBoJzmIli1UR3e6fuVhFsAXBRsx25iJo4XtfNtF+evbwsjhAix9waLEE2Cz9BrB3D5Lnw9Nt21UIJyvAWzJgXetU+z8EhBCOWPSeoC87WrP6TST67C3tMVJ7vqqpMgpIyZy3BXv9s+aREjwQ2bG3LMPGu3yTAFkWztd+eT7stgrIrm8uGgcQdLJ5K7Fp4wD+drCu3+EB+jK4BLTXGoBrKgpYffd9AU+tjgqC3UUBy2FnZcpNag27NtYnEbscdXaFOxAAAAAASUVORK5CYII=)
 */
export const LockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 9h1V6a5 5 0 0 1 10 0v3h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3Zm9-3v3H9V6a3 3 0 1 1 6 0Zm-1 8a2 2 0 0 1-1 1.73V18a1 1 0 1 1-2 0v-2.27A2 2 0 1 1 14 14Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
